import { connect } from "react-redux";
import { GetState } from "../../config/store";
import ChatFloatingButton from "../../components/ChatWidget/components/ChatFloatingButton/ChatFloatingButton";
import { toggleChat } from "../../actions/chat";

const mapStateToProps = (state: ReturnType<GetState>) => ({
    isOpen: state.chat.isOpen,
});

const mapDispatchToProps = (dispatch: any) => ({
    onClick: () => dispatch(toggleChat()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatFloatingButton);
